import { Header } from 'semantic-ui-react';
import { t } from '../../utils/resources';
import './NoAccess.less';

export const NoAccess = () => {
  return (
    <div className="no-access">
      <Header as={'h3'} inverted>
        {t('NoAccess.Title')}
      </Header>
      <br />
      <br />
      <br />

      <Header as={'h5'} inverted>
        {t('NoAccess.Text')}
      </Header>
    </div>
  );
};
